(function ($) {

  const initializeBlock = function ($block) {
    var viewport = document.documentElement.clientWidth
    var interval = null
    var last = $block.find('.tabbedMedia-tabsContent').children().length - 1

    function startInterval() {
      clearInterval(interval)
      interval = setInterval(updateTab, 6000);
    }
    function stopInterval() {
      clearInterval(interval)
    }

    if (viewport > 767) {
      var inview = new Waypoint.Inview({
        element: $block,
        enter: function(direction) {
          startInterval()
        },
        entered: function(direction) {
        },
        exit: function(direction) {
        },
        exited: function(direction) {
          stopInterval()
        }
      })
    }

    function updateTab() {
      var current = $block.find('.tabbedMedia').attr('data-current')

      if (current == last) {
        var next = 0
      } else {
        var next = parseInt(current) + 1
      }

      $block.find('.tabbedMedia-tab').removeClass('active')
      $block.find('.tabbedMedia-media').removeClass('active')

      $block.find('.tabbedMedia-tab[data-target="' + next + '"]').addClass('active')
      $block.find('.tabbedMedia-media[data-target="' + next + '"]').addClass('active')
      $block.find('.tabbedMedia').attr('data-current', next)
    }

    $('.tabbedMedia-tab').click(function(event) {
      clearInterval(interval)
      var target = $(this).attr('data-target');

      $block.find('.tabbedMedia-tab').removeClass('active')
      $block.find('.tabbedMedia-media').removeClass('active')

      $(this).addClass('active')
      $block.find('.tabbedMedia-media[data-target="' + target + '"]').addClass('active')
      $block.find('.tabbedMedia').attr('data-current', target)
    });
  }

  $(document).ready(function () {
    $('.block--tabbed-media').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=tabbed-media', initializeBlock);
  }

})(jQuery);